import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 rounded-full border-2 border-muted-foreground/20 border-t-foreground animate-spin" />
          <span className="text-xs uppercase tracking-widest text-muted-foreground">Carregando…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (
    user?.role === "commercial_master" ||
    user?.role === "commercial_consultant"
  ) {
    return <Navigate to="/commercial-portal" replace />;
  }

  return children;
}
